export default {
  groupName: 'ford-mx',
  appName: 'Ford Mexico',
  isAuto: true,
  image: 'ford.png',
  baseRoute: '/ford-mx',
  description:
  "Ford - Mexico Advertising Dashboard"
}



// WEBPACK FOOTER //
// ./src/app/configuration/FordMX/config/main.js